module.exports = __webpack_public_path__ + "img/emit.7d243ca1.png";